export default "__VITE_ASSET__CIVAoxCL__"